document.addEventListener("DOMContentLoaded", () => {
  let billingType = "monthly";

  const toggle = document.getElementById("billingToggle");
  const labels = document.querySelectorAll(".toggle-label");
  const cards = document.querySelectorAll(".pricing-card");

  initListeners();
  updateUI();

  function initListeners() {
    if (toggle) {
      toggle.addEventListener("click", () => {
        billingType = billingType === "monthly" ? "yearly" : "monthly";
        updateUI();
      });
    }

    labels.forEach(label => {
      label.addEventListener("click", () => {
        billingType = label.dataset.type;
        updateUI();
      });
    });

    cards.forEach(card => {
      const btn = card.querySelector(".subscribe-btn");
      if (btn) {
        btn.addEventListener("click", handleSubscribe);
      }
    });
  }

  function updateUI() {
    cards.forEach(card => {
      const monthlyView = card.querySelector(".price-monthly-view");
      const yearlyView  = card.querySelector(".price-yearly-view");
      const btn         = card.querySelector(".subscribe-btn");

      if (monthlyView) {
        monthlyView.style.display =
          billingType === "monthly" ? "block" : "none";
      }

      if (yearlyView) {
        yearlyView.style.display =
          billingType === "yearly" ? "block" : "none";
      }

      if (btn) {
        const planId =
          billingType === "monthly"
            ? btn.dataset.monthlyPlan
            : btn.dataset.yearlyPlan;

        changeSealPlan(planId, card.dataset.productId);
      }
    });

    labels.forEach(label => {
      label.classList.toggle(
        "active",
        label.dataset.type === billingType
      );
    });

  }

  async function handleSubscribe(e) {
    e.preventDefault();

    const btn = e.currentTarget;
    const card = btn.closest(".pricing-card");

    if (!card) return;

    btn.disabled = true;
    btn.textContent = "Processing...";

    const variantId =
      billingType === "yearly"
        ? btn.dataset.yearlyVariant
        : btn.dataset.monthlyVariant;

    const planId =
      billingType === "yearly"
        ? btn.dataset.yearlyPlan
        : btn.dataset.monthlyPlan;

    if (!variantId || !planId) {
      resetButton(btn);
      return;
    }

    try {
      const clearRes = await fetch("/cart/clear.js", {
        method: "POST"
      });

      if (!clearRes.ok) {
        throw new Error("Cart clear failed");
      }

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          selling_plan: planId
        })
      });

      if (!addRes.ok) {
        const errorData = await addRes.json();
        throw new Error(errorData.description || "Cart add failed");
      }

      window.location.href = "/checkout";

    } catch (error) {
      console.error(error);
      alert(error.message);
      resetButton(btn);
    }
  }

  function resetButton(btn) {
    btn.disabled = false;
    btn.textContent = "Subscribe";
  }
});

function changeSealPlan(planId, productId) {
  if (!planId || !productId) return;

  const widget = document.querySelector(
    `.pricing-card[data-product-id="${productId}"] .sealsubs-target-element`
  );

  if (!widget) return;

  widget.dispatchEvent(
    new CustomEvent("sealsubs:change_selected_selling_plan_id", {
      detail: { selling_plan_id: planId }
    })
  );
}

document.addEventListener("sealsubs:selling_plan_changed", (e) => {
  const planId = String(e.detail?.selling_plan_id);
  const widgetElement = e.detail?.element;

  if (!planId || !widgetElement) return;

  const card = widgetElement.closest(".pricing-card");
  if (!card) return;

  const btn = card.querySelector(".subscribe-btn");
  if (!btn) return;

  const monthlyPlan = String(btn.dataset.monthlyPlan);
  const yearlyPlan  = String(btn.dataset.yearlyPlan);

  const monthlyView = card.querySelector(".price-monthly-view");
  const yearlyView  = card.querySelector(".price-yearly-view");

  if (planId === monthlyPlan) {
    if (monthlyView) monthlyView.style.display = "block";
    if (yearlyView)  yearlyView.style.display = "none";
  }

  if (planId === yearlyPlan) {
    if (monthlyView) monthlyView.style.display = "none";
    if (yearlyView)  yearlyView.style.display = "block";
  }
});